import {
  setCheckButtons,
  setTableButtons,
  getCardFormHeadButtons
} from '@/utils/getbuttons.js'

const isOrgSection = (params) => params && params.theme === 'projectSection'
const isCompanyOrg = (params) => params && params.orgType === 'com'
const isProjectOrg = (params) => params && params.orgType === 'bigPro'
const isCompanyOrgSection = (params) => isOrgSection(params) && isCompanyOrg(params)
const isProjectOrgSection = (params) => isOrgSection(params) && isProjectOrg(params)

const withSelectedCompany = (list, uid, name) => {
  const options = Array.isArray(list) ? list.slice() : []
  const value = uid == null || uid === '' ? '' : String(uid)
  if (!value) {
    return options
  }
  if (!options.some((item) => item && String(item.value) === value)) {
    options.unshift({ label: name || value, value: value })
  }
  return options
}

const pickFormParent = (params, uidKey, nameKey) => {
  const form = (params && params.formValues) || {}
  const detail =
    (params &&
      params.state &&
      params.state.bidSection &&
      params.state.bidSection.bidSectionBaseInfo) ||
    {}
  const nested =
    (params &&
      params.state &&
      params.state.formValues &&
      params.state.formValues.bidSection &&
      params.state.formValues.bidSection.baseInfo) ||
    {}
  return {
    uid: form[uidKey] || detail[uidKey] || nested[uidKey] || '',
    name: form[nameKey] || detail[nameKey] || nested[nameKey] || ''
  }
}

const bidSection = {
  bidSection: {
    name: 'bidSection',
    theme: '项目标段',
    componentTypes: ['navigate', 'check', 'tables', 'cardForm'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    getListFun: 'bidSection/getBidSectionList',
    deleteFun: 'bidSection/deleteBidSection',
    getDetailFun: 'bidSection/getBidSectionInfo',
    headButtons: (params) => {
      if (isOrgSection(params)) {
        return setCheckButtons(['新增', '标记默认标段'])
      }
      return setCheckButtons(['新增'])
    },
    headTip: (params) => {
      if (!isOrgSection(params)) return ''
      return '列表单选标记某一机构为业务应用模块进入时查询数据的默认项目标段'
    },
    selectColumn: (params) => isOrgSection(params),
    selectSingle: (params) => isOrgSection(params),
    rowKey: 'orgUid',
    subcomponents: ['baseInfo', 'overview', 'contract'],
    cardFormNames: ['baseInfo', 'overview', 'contract'],
    queryParams: {
      projectUid: '',
      orgGroup: '',
      buildStatus: '',
      query: ''
    },
    selectData: [
      {
        key: 'projectUid',
        label: '所属工程',
        type: 'select',
        options: (params) => {
          return params.state.project.projectNames
        },
        checkByValue: true
      },
      {
        key: 'orgGroup',
        label: '项目活动类型',
        type: 'select',
        checkByValue: true,
        options: (params) => {
          return params.dictionarys.orgGroup
        }
      },
      {
        key: 'buildStatus',
        label: '项目状态',
        type: 'select',
        checkByValue: true,
        options: (params) => {
          return params.dictionarys.buildStatus
        }
      },
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '项目标段名称/所属企业'
      }
    ],
    detailPage: [
      {
        buttonName: '新增',
        type: 'cardForm',
        name: 'bidSection',
        theme: (params) => (isOrgSection(params) ? 'projectSection' : 'bidSection'),
        step: 'bidSectionInfo',
        label: '新增项目标段'
      },
      {
        buttonName: '编辑',
        type: 'cardForm',
        name: 'bidSection',
        theme: (params) => (isOrgSection(params) ? 'projectSection' : 'bidSection'),
        step: 'bidSectionInfo',
        label: '编辑项目标段',
        checkType: 'checkByUid',
        checkFun: 'bidSection/getBidSectionInfo'
      }
    ],
    rowData: (params) => {
      return params.state.bidSection.bidSectionList.result
    },
    rowTotal: (params) => {
      return params.state.bidSection.bidSectionList.totalSize
    },
    columns: [
      {
        prop: 'orgName',
        label: '项目标段简称',
        width: '',
        badgeKey: 'isDefaultBid',
        badgeText: '默认'
      },
      { prop: 'projectName', label: '所属工程', width: '360px' },
      {
        prop: 'parentCompanyName',
        label: '所属企业',
        width: '360px'
      },
      { prop: 'orgGroup', label: '项目活动类型', width: '' },
      {
        prop: 'buildStatus',
        label: '项目状态',
        tag: [
          { type: 'success', label: '在建' },
          { type: 'danger', label: '停工' },
          { type: 'info', label: '竣工' },
          { type: 'info', label: '运营养护' },
          { type: 'warning', label: '交工' },
          { type: 'warning', label: '缺陷维修' },
          { type: 'warning', label: '完工' }
        ]
      },
      {
        label: '操作',
        buttons: setTableButtons(['编辑', '删除', '二维码', '披露二维码']),
        width: '320px'
      }
    ],
    hasPagination: true,
    baseInfo: {
      addFun: 'bidSection/addBidSection',
      editFun: 'bidSection/editBidSection',
      getDetailFun: 'bidSection/getBidSectionBaseInfo',
      formParams: {
        name: '',
        projectCode: '',
        projectNum: '',
        buildStatus: '',
        parentCompanyUid: (params) => {
          return isCompanyOrgSection(params) ? params.orgValue : ''
        },
        parentCompanyName: '',
        projectUid: (params) => {
          return isProjectOrgSection(params) ? params.orgValue : ''
        },
        projectName: '',
        activityType: '',
        isCompanyKey: '是',
        isInsurance: '有购买',
        buildCompanyName: '',
        buildCompany: '',
        projectType: '',
        licence: '',
        buildNature: '',
        fundingSource: '',
        engPurpose: ''
      },
      formRules: {
        name: [
          {
            required: true,
            message: '请输入项目标段全称',
            trigger: 'blur'
          }
        ],
        projectCode: [
          {
            required: true,
            message: '请输入项目标段简称',
            trigger: 'blur'
          }
        ],
        projectNum: [
          {
            required: true,
            message: '请输入项目编号',
            trigger: 'blur'
          }
        ],
        buildStatus: [
          {
            required: true,
            message: '请选择项目状态',
            trigger: 'blur'
          }
        ],
        activityType: [
          {
            required: true,
            message: '请选择项目活动类型',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          card: '基础信息',
          headButtons: getCardFormHeadButtons(0),
          fields: [
            {
              key: 'name',
              label: '项目标段名称',
              type: 'input',
              placeholder: '请输入项目标段全称'
            },
            {
              key: 'projectCode',
              label: '项目标段简称',
              type: 'input',
              placeholder: '请输入项目标段简称'
            },
            {
              key: 'projectNum',
              label: '项目编号',
              type: 'input'
            },
            {
              key: 'buildStatus',
              label: '项目状态',
              type: 'select',
              options: (params) => {
                return params.dictionarys.buildStatus
              }
            },
            {
              key: 'parentCompanyUid',
              checkKey: 'parentCompanyName',
              echoLabelKey: 'parentCompanyName',
              label: '所属企业',
              type: 'select',
              placeholder: (params) => {
                return isCompanyOrgSection(params)
                  ? '自动关联当前企业'
                  : '选填，可在组织结构中关联'
              },
              filterable: true,
              clearable: (params) => !isCompanyOrgSection(params),
              remote: (params) => !isCompanyOrgSection(params),
              disabled: (params) => isCompanyOrgSection(params),
              options: (params) => {
                const selected = pickFormParent(
                  params,
                  'parentCompanyUid',
                  'parentCompanyName'
                )
                if (isCompanyOrgSection(params) && params.orgValue) {
                  return withSelectedCompany(
                    [{ label: params.orgName, value: params.orgValue }],
                    selected.uid,
                    selected.name
                  )
                }
                return withSelectedCompany(
                  params.state.enterprise.enterprises,
                  selected.uid,
                  selected.name
                )
              },
              checkByValue: true
            },
            {
              key: 'projectUid',
              checkKey: 'projectName',
              echoLabelKey: 'projectName',
              label: '所属工程',
              type: 'select',
              placeholder: (params) => {
                return isProjectOrgSection(params)
                  ? '自动关联当前工程'
                  : '选填，可在组织结构中关联'
              },
              filterable: true,
              clearable: (params) => !isProjectOrgSection(params),
              disabled: (params) => isProjectOrgSection(params),
              options: (params) => {
                const selected = pickFormParent(
                  params,
                  'projectUid',
                  'projectName'
                )
                if (isProjectOrgSection(params) && params.orgValue) {
                  return withSelectedCompany(
                    [{ label: params.orgName, value: params.orgValue }],
                    selected.uid,
                    selected.name
                  )
                }
                return withSelectedCompany(
                  params.state.project.projectNames,
                  selected.uid,
                  selected.name
                )
              },
              checkByValue: true
            },
            {
              key: 'activityType',
              label: '项目活动类型',
              type: 'select',
              options: (params) => {
                return params.dictionarys.orgGroup
              }
            },
            {
              key: 'isCompanyKey',
              label: '是否企业重点',
              type: 'select',
              options: (params) => {
                return params.dictionarys.isFalse
              }
            },
            {
              key: 'isInsurance',
              label: '是否缴纳保险',
              type: 'select',
              options: (params) => {
                return params.dictionarys.isFalse
              }
            },
            {
              key: 'buildCompanyName',
              label: '建设单位',
              type: 'input',
              disabled: true
            },
            {
              key: 'projectType',
              label: '项目分类',
              type: 'input',
              disabled: true
            },
            {
              key: 'licence',
              label: '施工许可证',
              type: 'input',
              disabled: true
            },
            {
              key: 'buildNature',
              label: '建设性质',
              type: 'input',
              disabled: true
            },
            {
              key: 'fundingSource',
              label: '资金来源',
              type: 'input',
              disabled: true
            },
            {
              key: 'engPurpose',
              label: '工程用途',
              type: 'input',
              disabled: true
            }
          ]
        }
      ]
    },
    overview: {
      editFun: 'bidSection/editBidSection',
      getDetailFun: 'bidSection/getBidSectionOverview',
      formParams: {
        position: '',
        gpsInfo: '',
        gps: {
          lng: 0, // 经度
          lat: 0 // 纬度
        },
        projectArea: '',
        projectSize: '',
        projectIntroduc: ''
      },
      formRules: {
        position: [
          {
            required: true,
            message: '请选择项目所在地',
            trigger: 'blur'
          }
        ],
        gpsInfo: [
          {
            required: true,
            message: '请获取项目坐标',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          card: '项目概况',
          headButtons: getCardFormHeadButtons(1),
          fields: [
            {
              key: 'position',
              label: '项目所在地',
              type: 'input',
              placeholder: '请在地图中点选',
              inputButton: '地图点选',
              buttonIcon: 'el-icon-location-outline input_button_i',
              span: 24
            },
            {
              key: 'gpsInfo',
              label: '项目坐标',
              type: 'input',
              placeholder: '地图点选后自动获取',
              disabled: true
            },
            {
              key: 'projectArea',
              label: '建筑面积',
              type: 'input',
              inputButton: '㎡'
            },
            {
              key: 'projectSize',
              label: '里程长度',
              type: 'input',
              inputButton: 'km'
            },
            {
              key: 'projectIntroduc',
              label: '项目标段简介',
              type: 'input',
              placeholder: '请输入项目标段简介',
              inputType: 'textarea',
              autosize: { minRows: 6, maxRows: 8 },
              span: 24
            }
          ]
        }
      ]
    },
    contract: {
      editFun: 'bidSection/editBidSection',
      getDetailFun: 'bidSection/getBidSectionContract',
      formParams: {
        contractCompanyUid: '',
        dateAward: '',
        planStartDate: '',
        planEndDate: '',
        contractDate: '',
        contractMoney: ''
      },
      formRules: {
        contractCompanyUid: [
          { required: true, message: '请选择承包企业', trigger: 'blur' }
        ],
        planStartDate: [
          {
            validator: (params) => {
              return params.validate.validatePlanStartDate
            },
            trigger: 'blur'
          }
        ],
        planEndDate: [
          {
            validator: (params) => {
              return params.validate.validatePlanEndDate
            },
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          card: '承包信息',
          headButtons: getCardFormHeadButtons(1),
          fields: [
            {
              key: (params) => {
                return params.pageStatus === 'add' ||
                  params.pageStatus === 'edit'
                  ? 'contractCompanyUid'
                  : 'contractCompanyName'
              },
              label: '承包单位',
              type: 'select',
              placeholder: '请输入关键词搜索',
              filterable: true,
              remote: true, // 关键词远程搜索
              options: (params) => {
                const form = params.formValues || {}
                return withSelectedCompany(
                  params.state.enterprise.enterprises,
                  form.contractCompanyUid,
                  form.contractCompanyName
                )
              },
              checkByValue: true
            },
            {
              key: 'dateAward',
              label: '中标日期',
              type: 'time',
              timetype: 'date',
              format: 'yyyy-MM-dd'
            },
            {
              key: 'planStartDate',
              label: '计划开工日期',
              type: 'time',
              timetype: 'date',
              format: 'yyyy-MM-dd'
            },
            {
              key: 'planEndDate',
              label: '计划竣工日期',
              type: 'time',
              timetype: 'date',
              format: 'yyyy-MM-dd'
            },
            {
              key: 'contractDate',
              label: '合同工期',
              type: 'input',
              inputButton: '天',
              disabled: true
            },
            {
              key: 'contractMoney',
              label: '承包合同额',
              type: 'input',
              inputButton: '万元',
              span: 8
            }
          ]
        }
      ]
    }
  }
}

export default bidSection
